import { render, staticRenderFns } from "./KpiHealthCoachBanner.vue?vue&type=template&id=30900bb8&scoped=true&"
import script from "./KpiHealthCoachBanner.vue?vue&type=script&lang=js&"
export * from "./KpiHealthCoachBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30900bb8",
  null
  
)

export default component.exports